import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { inject } from '@angular/core';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  const loggingService = inject(LoggingService);
  loggingService.error(err);
});
